import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type DepartmentDto = {
  id: string;
  name: string;
};

export type UserProfileDto = {
  userId: string;
  email: string;
  displayName: string;
  departmentId: string | null;
  departmentName: string | null;
};

export type UpdateUserProfileRequest = {
  displayName: string;
  departmentId: string | null;
};

export type UserStatsDto = {
  ideasSubmitted: number;
  totalPoints: number;
};

@Injectable({ providedIn: 'root' })
export class UserProfileApiService {
  constructor(private readonly http: HttpClient) {}

  getDepartments(): Observable<DepartmentDto[]> {
    return this.http.get<DepartmentDto[]>('/api/departments');
  }

  getMyProfile(): Observable<UserProfileDto> {
    return this.http.get<UserProfileDto>('/api/users/me/profile');
  }

  updateMyProfile(body: UpdateUserProfileRequest): Observable<UserProfileDto> {
    return this.http.put<UserProfileDto>('/api/users/me/profile', body);
  }

  getMyStats(): Observable<UserStatsDto> {
    return this.http.get<UserStatsDto>('/api/users/me/stats');
  }
}
